module.exports = __webpack_public_path__ + "img/hopdong.b0168bea.svg";